import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
  state: {
    user: false,
    authList: [],
  },
  mutations: {
    // 登录
    login(state, user) {
      state.user = user;
      localStorage.setItem("userInfo", user);
    },
    // 退出
    logout(state, user) {
      state.user = user;
      localStorage.setItem("userInfo", user);
    }
  },
  actions: {
    async authSelf(state, data) {
      this.state.authList = data
    },
    // check_auth(value: string) {
    //     return this.state.authList.some((v) => v.index === value);
    // },
  },
})



// WEBPACK FOOTER //
// ./src/vuex/store.js